import { render, staticRenderFns } from "./allot-role.vue?vue&type=template&id=5af483d6&scoped=true"
import script from "./allot-role.vue?vue&type=script&lang=ts"
export * from "./allot-role.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af483d6",
  null
  
)

export default component.exports